import React from "react";

import {Select} from "antd";

import {SimpleForecasting} from "./SimpleForecasting";
import {labelMapper} from "../../helpers";
import {DataCard} from "../helpers/cards/Card";
import {CrostonForecast} from "../helpers/modals/CorstonModal";

export function Forecasts({
	projectId,
	material,
	itemInfo,
	forecastMin,
	forecastMax,
	onRecAdd,
	change,
	currentRec,
	constants,
	handleSelect,
	canEdit = true,
	forecastMethod = "naive",
}) {
	const getForecastOptions = () => [
		{
			value: "naive",
			label: labelMapper("naive"),
		},
		{
			value: "bom",
			label: labelMapper("bom"),
		},
		{
			value: "combined",
			label: labelMapper("combined"),
		},
	];

	return (
		<DataCard>
			<Select
				options={getForecastOptions()}
				onSelect={handleSelect}
				style={{width: 250}}
				value={forecastMethod}
			/>

			{["naive", "bom", "combined"].includes(forecastMethod) && (
				<SimpleForecasting
					projectId={projectId}
					canEdit={canEdit}
					change={change}
					constants={constants}
					currentRec={currentRec}
					itemInfo={itemInfo}
					forecastMin={forecastMin}
					onRecAdd={onRecAdd}
					forecastMethod={forecastMethod}
					material={material}
					forecastMax={forecastMax}
				/>
			)}

			{forecastMethod === "croston" && <CrostonForecast projectId={projectId} show={true} material={material} />}
		</DataCard>
	);
}
